const user = JSON.parse(localStorage.getItem('user'));

export default {
  user: {
    ...user,
    admin_type: "s_admin",
    permissions:
      user?.roles
        ?.map((role) => role.permissions)
        .concat(user.permissions)
        .map((permission) => permission.name) || [],
  },
};
